import React from 'react'
import { NavLink } from 'react-router-dom'
import Routes from './../pages/_routes'

// import Banner from './banner'

class Header extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			isExpanded: false
		}

		this.handleLogoClick = this.handleLogoClick.bind(this)
		this.handleMenuTriggerClick = this.handleMenuTriggerClick.bind(this)
		this.handleLinkClick = this.handleLinkClick.bind(this)
	}

	handleLinkClick(e){
		this.setState({ isExpanded: false })
	}

	handleLogoClick(e){
		if(this.state.isExpanded){
			this.setState({ isExpanded: !this.state.isExpanded })
		}
	}

	handleMenuTriggerClick(e){
		this.setState({ isExpanded: !this.state.isExpanded })
	}

	render() {
		return (
			<React.Fragment>
				<header className={this.state.isExpanded ? 'expanded' : ''}>
					<div className="container">
						<NavLink to="/" exact activeClassName="active" className="logo" onClick={this.handleLogoClick}></NavLink>
						<span className="menuTrigger" onClick={this.handleMenuTriggerClick}>
							<span></span>
							<span></span>
							<span></span>
						</span>
						<nav>
							<NavLink to="/" exact activeClassName="active" onClick={this.handleLogoClick}>Home</NavLink>
							{Routes.Header.map( (route, index) => {
								return <NavLink activeClassName="active" key={index} to={route.path} className={route.className} onClick={this.handleLinkClick}>{route.label}</NavLink>
							})}
							<a href="https://app.arts-people.com/index.php?ticketing=dehs" className="ticket_cta" target="_blank" rel="noopener noreferrer">Buy Tickets</a>
						</nav>
					</div>
				</header>
				{/*<Banner />*/}
			</React.Fragment>
		)
	}
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js